module.exports = require('promise/lib/es6-extensions')
